
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 111 116","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#00E196","d":"M56 58.66v23.747l27.965 14.78z"}}),_c('path',{attrs:{"fill":"#0FA","d":"M83.965 97.187L78.696 65.94l22.494-22.014L56 58.66z"}}),_c('path',{attrs:{"fill":"#00E196","d":"M101.19 43.926L56 58.66V11l13.982 28.263z"}}),_c('path',{attrs:{"fill":"#0FA","d":"M56 58.66v23.747l-27.965 14.78z"}}),_c('path',{attrs:{"fill":"#00E196","d":"M28.035 97.187l5.269-31.247L10.81 43.926 56 58.66z"}}),_c('path',{attrs:{"fill":"#00B679","d":"M10.81 43.926L56 58.66V11L42.018 39.263z"}}),_c('g',{attrs:{"fill":"#0FA"}},[_c('path',{attrs:{"d":"M88.07.723l.937 12.667 4.59-4.232-4.04 4.942 12.938.63-12.937 1.078 4.039 4.67-4.59-3.967-.937 12.561zM88.07.836l-.582 12.83-4.59-4.231 4.04 4.942-12.938.63 12.937 1.078-4.04 4.67 4.591-3.967.582 12.15z"}})]),_c('g',{attrs:{"fill":"#0FA"}},[_c('path',{attrs:{"d":"M99 78l.78 10.723 3.818-3.582-3.36 4.184 10.762.534-10.763.912 3.36 3.953-3.818-3.358L99 102zM99 79l-.496 10.501-3.915-3.463 3.445 4.045L87 90.599l11.034.882-3.445 3.822 3.915-3.247L99 102z"}})]),_c('g',{attrs:{"fill":"#0FA"}},[_c('path',{attrs:{"d":"M13 90l.844 11.617 4.137-3.881-3.64 4.532 11.659.579-11.66.988 3.641 4.283-4.137-3.638L13 116zM13 91l-.538 11.414-4.24-3.764 3.731 4.396L0 103.607l11.953.959-3.732 4.154 4.241-3.529L13 116z"}})]),_c('g',{attrs:{"fill":"#0FA"}},[_c('path',{attrs:{"d":"M17 14l.65 8.936 3.182-2.985-2.8 3.486 8.968.445-8.969.76 2.8 3.295-3.182-2.799L17 34zM17 15l-.414 8.675-3.262-2.861 2.871 3.341L7 24.582l9.195.728-2.871 3.157 3.262-2.682L17 34z"}})])])])
          )
        }
      }
    